import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';

export const FETCH_DEVICEINFO_LOADING = 'FETCH_DEVICEINFO_LOADING';
export const FETCH_DEVICEINFO_SUCCESS = 'FETCH_DEVICEINFO_SUCCESS';
export const FETCH_DEVICEINFO_FAILED = 'FETCH_DEVICEINFO_FAILED';

export const FETCH_DEVICEONOFF_LOADING = 'FETCH_DEVICEONOFF_LOADING';
export const FETCH_DEVICEONOFF_SUCCESS = 'FETCH_DEVICEONOFF_SUCCESS';
export const FETCH_DEVICEONOFF_FAILED = 'FETCH_DEVICEONOFF_FAILED';

export const FETCH_DEVICECENTER_LOADING = 'FETCH_DEVICECENTER_LOADING';
export const FETCH_DEVICECENTER_SUCCESS = 'FETCH_DEVICECENTER_SUCCESS';
export const FETCH_DEVICECENTER_FAILED = 'FETCH_DEVICECENTER_FAILED';

export const FETCH_DEVICESUBDEVICE_LOADING = 'FETCH_DEVICESUBDEVICE_LOADING';
export const FETCH_DEVICESUBDEVICE_SUCCESS = 'FETCH_DEVICESUBDEVICE_SUCCESS';
export const FETCH_DEVICESUBDEVICE_FAILED = 'FETCH_DEVICESUBDEVICE_FAILED';

/**
 * 重置设备数据
 * @param {*} param
 */
export function resetData(data, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_DEVICEINFO_SUCCESS,
      deviceInfo: {},
    });
    dispatch({
      type: FETCH_DEVICEONOFF_SUCCESS,
      deviceOnoffList: [],
      deviceOnoffListTotal: 0,
    });
    dispatch({
      type: FETCH_DEVICECENTER_SUCCESS,
      centerList: {},
    });
    dispatch({
      type: FETCH_DEVICESUBDEVICE_SUCCESS,
      subList: [],
    });

  };
}

/**
 * 获取设备信息
 * @param {*} param
 */
export function fetchDeviceInfo(param, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      subSerial: ''
    }
    const req = Object.assign({}, defaultParam, param);
    const { subSerial = '' } = req;
    if(subSerial == '') {
      dispatch({
        type: FETCH_DEVICEINFO_SUCCESS,
        deviceInfo: {},
      });
      return;
    }
    dispatch({
      type: FETCH_DEVICEINFO_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/device/info`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        if(res.data){
          dispatch({
            type: FETCH_DEVICEINFO_SUCCESS,
            deviceInfo: res.data || {},
          });
        }else{
          message.error(intl.get('home.common.notFoundContent'));
          dispatch({
            type: FETCH_DEVICEINFO_SUCCESS,
            deviceInfo: {}
          });
        }
        callback && callback();
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_DEVICEINFO_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_DEVICEINFO_FAILED,
      });
    })
  };
}

/**
 * 获取设备上下线信息
 * @param {*} param
 */
export function fetchDeviceOnoff(param) {
  return (dispatch, getState) => {
    const { subSerial } = getState().queryDevice.deviceInfo;
    const defaultParam = {
      subSerial,
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_DEVICEONOFF_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/device/onoff`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_DEVICEONOFF_SUCCESS,
          deviceOnoffList: res.data.content || [],
          deviceOnoffListTotal: res.data.totalSize || 0,
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_DEVICEONOFF_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_DEVICEONOFF_FAILED,
      });
    })
  };
}

/**
 * 获取设备网关中心节点
 * @param {*} param
 */
export function fetchDeviceCenterDevice(param) {
  return (dispatch, getState) => {
    const { subSerial } = getState().queryDevice.deviceInfo;
    const defaultParam = {
      subSerial,
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_DEVICECENTER_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/device/centerDevice`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_DEVICECENTER_SUCCESS,
          centerList: res.data || {},
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_DEVICECENTER_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_DEVICECENTER_FAILED,
      });
    })
  };
}

/**
 * 获取设备网关子设备
 * @param {*} param
 */
export function fetchDeviceSubDeviceInfo(param) {
  return (dispatch, getState) => {
    const { subSerial } = getState().queryDevice.deviceInfo;
    const defaultParam = {
      subSerial,
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_DEVICESUBDEVICE_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/device/listSubDeviceInfos`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_DEVICESUBDEVICE_SUCCESS,
          subList: res.data || [],
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_DEVICESUBDEVICE_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_DEVICESUBDEVICE_FAILED,
      });
    })
  };
}

